import { AuthenticationService } from './../../shared/authentication.service';
import { DisputedetailswithquestioninfoComponent } from './../disputedetailswithquestioninfo/disputedetailswithquestioninfo.component';
import { QATicketDisputeDetails } from '../../shared/qaTicket';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { QATicketNotes } from '../../shared/qaTicket';
import { QuestionService } from '../../shared/questionService';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-disputedetails",
  templateUrl: "./disputedetails.component.html",
  styleUrls: ["./disputedetails.component.scss"]
})

export class DisputedetailsComponent implements OnInit {

  disputedetails: QATicketDisputeDetails[];

  constructor(public dialogRef: MatDialogRef<DisputedetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private questionService: QuestionService,
    public dialog: MatDialog,
    public auth: AuthenticationService,
    private router: Router) {

  }

  ngOnInit() {
  }

  onDisputeClick(ID: number) {
      this.questionService.getDisputeDetailsWithQuestionInfo(ID, this.auth.currentState).subscribe((res: QATicketDisputeDetails[]) => {
      this.disputedetails = res;

      let dialogopen = this.dialog.open(DisputedetailswithquestioninfoComponent, {
        width: '600px',
        data: {
            disputes: this.disputedetails,
            QuestionId: this.disputedetails[0].QuestionId,
          QATicketActivityId: this.disputedetails[0].QATicketActivityId,
          IsDisputeComplete: this.disputedetails[0].IsComplete
        }
      });

      dialogopen.afterClosed().subscribe(result => {
        this.questionService.getDisputeDetails(this.data.disputes[0].QATicketId, this.auth.currentState).subscribe(res => {
          this.data.disputes = res;
          this.data.disputes.forEach(item => {
            if (item.IsComplete) {
              item.Status = 'Dispute Close';
              item.DateOn = item.Completion;
              item.UserBy = item.ActivityCompleteBy;
            }
            else {
              item.Status = 'Dispute Open';
              item.DateOn = item.Creation;
              item.UserBy = item.ActivityCreatedBy;
            }
          });
        });
      });
    });
  }
  OnCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  AddDispute(){
    
    var username = this.auth.username;
    username = username.replace(".", "-");
    this.router.navigate(["/disputeticketonquestion", this.data.QATicketId, username]);
    this.dialogRef.close('Confirm');
  }
}
